var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeToUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6678 9.30469H11.8262V12.0735H14.1871V11.2319H12.6678V9.30469Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2879 7.89453C11.3635 7.89453 10.5237 8.25173 9.89208 8.83279L9.76523 8.77454L8.89733 8.04243L7.40573 9.52578L5.91044 8.04243L5.04253 8.77454L3.23601 9.60596C2.96882 9.71596 2.73162 9.90544 2.57267 10.1723L0 14.472H10.4352C10.9753 14.8045 11.6082 14.9999 12.2877 14.9999C14.2467 14.9999 15.8404 13.4062 15.8404 11.4472C15.8404 9.48824 14.2469 7.89453 12.2879 7.89453ZM12.2879 13.9473C10.9096 13.9473 9.78787 12.8257 9.78787 11.4472C9.78787 10.0688 10.9096 8.94718 12.2879 8.94718C13.6662 8.94718 14.7879 10.0688 14.7879 11.4472C14.7879 12.8257 13.6662 13.9473 12.2879 13.9473Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39373 8.22135V8.22223C7.39548 8.22223 7.39723 8.22188 7.39881 8.22188C7.39987 8.22188 7.40127 8.22223 7.40232 8.22223C7.40267 8.22223 7.40302 8.22223 7.40373 8.22223C7.40408 8.22223 7.40478 8.22223 7.40478 8.22223C7.40618 8.22223 7.40759 8.22188 7.40829 8.22188C7.41004 8.22188 7.4118 8.22223 7.41337 8.22223V8.22135C9.5199 8.25363 10.8001 6.41027 10.8327 3.3711C10.854 1.26265 9.54674 0.0571939 7.41706 0.000350899V0C7.4139 0 7.41162 0.000350899 7.40811 0.000350899V0C7.40636 0 7.40495 1.63801e-08 7.40373 0.000350899C7.40232 1.63801e-08 7.40057 0 7.39881 0V0.000350899C7.39566 0.000350899 7.39302 0 7.39022 0V0.000701756C5.26106 0.0575447 3.95315 1.263 3.97438 3.37145C4.00753 6.41027 5.28773 8.25346 7.39373 8.22135Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeToUserIcon);
export default __webpack_public_path__ + "static/media/timeToUserIcon.16c035e1ecc224ca38f6d2910051bcf6.svg";
export { ForwardRef as ReactComponent };